"use client";
import React, { useEffect, useRef, useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaRegImages, FaRegUserCircle } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";
import { GrImage } from "react-icons/gr";
import { IoHomeOutline } from "react-icons/io5";
import { LuImage, LuImagePlus } from "react-icons/lu";
import { RiImageAddLine, RiMenu2Line } from "react-icons/ri";
import { VscFolder, VscNewFolder } from "react-icons/vsc";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLoggedIn } from "../../store/slice/auth";

const Header = () => {
  const menuRef = useRef();
  const dispatch = useDispatch();
  const [toggleShow, setToggleShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  const navigate = useNavigate();
  const location = window.location.pathname;

  const sidebarMenusURL = (item) => {
    navigate(item.url);
    toggleMenu();
  };

  const sidebarMenus = [
    {
      sideIcon: (
        <IoHomeOutline className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Dashboard",
      url: "/dashboard",
    },
    {
      sideIcon: (
        <VscFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Categories",
      url: "/categories",
    },
    {
      sideIcon: (
        <VscNewFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Categories",
      url: "/add-categories",
    },
    {
      sideIcon: (
        <VscFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Collections",
      url: "/collections",
    },
    {
      sideIcon: (
        <VscNewFolder className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Collections",
      url: "/add-collections",
    },
    {
      sideIcon: <LuImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Images",
      url: "/images",
    },
    {
      sideIcon: (
        <LuImagePlus className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add 4k Images",
      url: "/add-images",
    },
    {
      sideIcon: (
        <RiImageAddLine className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Multi 4k Images",
      url: "/add-multi-images",
    },
    {
      sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "4D Parallax",
      url: "/parallax",
    },
    {
      sideIcon: (
        <FaRegImages className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Multi 4D Images",
      url: "/multi-parallax",
    },
    {
      sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "Live Wallpapers",
      url: "/wallpaper",
    },
    {
      sideIcon: (
        <FaRegImages className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Multi Live Wallpapers",
      url: "/multi-wallpaper",
    },
    {
      sideIcon: <GrImage className="group-hover:bg-gray-800 bg-transparent" />,
      name: "3D Wallpapers",
      url: "/3d-wallpaper",
    },
    {
      sideIcon: (
        <FaRegImages className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Multi 3D Wallpapers",
      url: "/multi-3d-wallpaper",
    },
    {
      sideIcon: (
        <LuImagePlus className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add HDR Images",
      url: "/add-hdr-images",
    },
    {
      sideIcon: (
        <RiImageAddLine className="group-hover:bg-gray-800 bg-transparent" />
      ),
      name: "Add Multi HDR Images",
      url: "/add-multi-hdr-images",
    },
  ];

  const LogOut = () => {
    localStorage.clear();
    dispatch(setLoggedIn(false));
  };

  return (
    <>
      <div
        className="w-full border-b border-gray-600 sticky top-0 left-0 z-100 bg-primary"
        ref={menuRef}
      >
        <div className="flex justify-between md:justify-end items-center">
          <div className="cursor-pointer p-4 md:hidden inline-block">
            <div className="relative">
              <RiMenu2Line
                onClick={toggleMenu}
                className="text-white text-2xl"
              />
              <div
                className={`fixed inset-0 bg-gray-900 bg-opacity-50 z-40 transition-opacity ${
                  isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
                }`}
                onClick={toggleMenu}
              ></div>
              <div
                className={`fixed inset-y-0 left-0 w-64 bg-gray-800 z-50 shadow-lg transform transition duration-300 ${
                  isOpen ? "translate-x-0" : "-translate-x-full"
                }`}
              >
                <div className="p-4">
                  <div className="flex justify-between items-center">
                    <h1 className="text-lg font-bold text-white">Menu</h1>
                    <div onClick={toggleMenu}>
                      <CgClose className="text-white text-2xl" />
                    </div>
                  </div>
                  <ul className="flex-1 pt-5">
                    {sidebarMenus.map((item, index) => (
                      <li
                        key={index}
                        className={`
                            relative flex items-center gap-3 py-2 px-3 my-1 h-10 group
                            font-medium rounded-md cursor-pointer hover:bg-gray-800 hover:text-white
                            ${
                              location.includes(item.url)
                                ? "bg-gray-800 text-white"
                                : " text-gray-400"
                            }
                        `}
                        onClick={() => sidebarMenusURL(item)}
                      >
                        {item.sideIcon}
                        <span
                          className={`overflow-hidden group-hover:bg-gray-800 group-hover:text-white ${
                            location.includes(item.url)
                              ? "bg-gray-800 text-white"
                              : " text-gray-400"
                          }`}
                        >
                          {item.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="relative flex justify-end cursor-pointer p-4">
            <FaRegUserCircle
              onClick={userToggle}
              className="text-27 text-white"
            />
            <div
              className={`${
                toggleShow ? "block" : "hidden"
              } absolute top-14  py-3 px-5 rounded-6 shadow-md flex gap-3 items-center bg-white`}
              onClick={LogOut}
            >
              <FaPowerOff className="text-primary bg-white font-medium" />
              <span className="font-medium text-primary bg-white leading-none">
                Logout
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
